/**
 * @fileoverview gRPC-Web generated client stub for stronachgroup.first.racehorse360
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.1
// 	protoc              v0.0.0
// source: stronachgroup/first/racehorse360/notification_service.proto

/* eslint-disable */
// @ts-nocheck

const grpc = {};
grpc.web = require("grpc-web");

var google_api_annotations_pb = require("../../../google/api/annotations_pb.js");

var google_api_visibility_pb = require("../../../google/api/visibility_pb.js");

var stronachgroup_first_racehorse360_messages_pb = require("../../../stronachgroup/first/racehorse360/messages_pb.js");
const proto = {};
proto.stronachgroup = {};
proto.stronachgroup.first = {};
proto.stronachgroup.first.racehorse360 = require("./notification_service_pb.js");

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.stronachgroup.first.racehorse360.NotificationServiceClient =
  function NotificationServiceClient(hostname, credentials, options) {
    if (!options) options = {};
    options.format = "text";

    /**
     * @private @const {!grpc.web.GrpcWebClientBase} The client
     */
    this.client_ = new grpc.web.GrpcWebClientBase(options);

    /**
     * @private @const {string} The hostname
     */
    this.hostname_ = hostname.replace(/\/+$/, "");
  };

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.stronachgroup.first.racehorse360.NotificationServicePromiseClient =
  function NotificationServicePromiseClient(hostname, credentials, options) {
    if (!options) options = {};
    options.format = "text";

    /**
     * @private @const {!grpc.web.GrpcWebClientBase} The client
     */
    this.client_ = new grpc.web.GrpcWebClientBase(options);

    /**
     * @private @const {string} The hostname
     */
    this.hostname_ = hostname.replace(/\/+$/, "");
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.PullNotificationsRequest,
 *   !proto.stronachgroup.first.racehorse360.PullNotificationsResponse>}
 */
const methodDescriptor_NotificationService_PullNotifications =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.NotificationService/PullNotifications",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.PullNotificationsRequest,
    stronachgroup_first_racehorse360_messages_pb.PullNotificationsResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.PullNotificationsRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.PullNotificationsResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullNotificationsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.PullNotificationsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.PullNotificationsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.NotificationServiceClient.prototype.pullNotifications =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.NotificationService/PullNotifications",
      request,
      metadata || {},
      methodDescriptor_NotificationService_PullNotifications,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullNotificationsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.PullNotificationsResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.NotificationServicePromiseClient.prototype.pullNotifications =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.NotificationService/PullNotifications",
      request,
      metadata || {},
      methodDescriptor_NotificationService_PullNotifications
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.MarkNotificationsAsReadRequest,
 *   !proto.stronachgroup.first.racehorse360.EmptyResponse>}
 */
const methodDescriptor_NotificationService_MarkNotificationsAsRead =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.NotificationService/MarkNotificationsAsRead",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.MarkNotificationsAsReadRequest,
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.MarkNotificationsAsReadRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.MarkNotificationsAsReadRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.EmptyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.EmptyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.NotificationServiceClient.prototype.markNotificationsAsRead =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.NotificationService/MarkNotificationsAsRead",
      request,
      metadata || {},
      methodDescriptor_NotificationService_MarkNotificationsAsRead,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.MarkNotificationsAsReadRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.EmptyResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.NotificationServicePromiseClient.prototype.markNotificationsAsRead =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.NotificationService/MarkNotificationsAsRead",
      request,
      metadata || {},
      methodDescriptor_NotificationService_MarkNotificationsAsRead
    );
  };

module.exports = proto.stronachgroup.first.racehorse360;
